import { createAction } from 'typesafe-actions'

export const fetchAddEmails = createAction('@@SendEmail/fetchAddEmails')<string[]>()
export const fetchGetList = createAction('@@SendEmail/fetchGetList')()
export const fetchRemoveEmail = createAction('@@SendEmail/fetchRemoveEmail')<string>()
export const fetchSendEmails = createAction('@@SendEmail/fetchSendEmails')()
export const fetchSendTo = createAction('@@SendEmail/fetchSendTo')<string>()
export const onSetLastSend = createAction('@@SendEmail/onSetLastSend')<string>()
